import { DishFetch } from "../index";

export default function DishFetchFunc(id: any) {
  const categoryId: any = {
    id: id,
  };
  return DishFetch(categoryId);
}
